import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../core/providers';
import { Heap } from '../../core/interface/heap';

@Component({
  selector: 'app-sign-out',
  templateUrl: './sign-out.component.html',
  styleUrls: ['./sign-out.component.scss'],
  standalone: false,
})
export class SignOutComponent implements OnInit {
  constructor(
    public authentictionService: AuthenticationService,
    public router: Router
  ) {}

  ngOnInit() {
    this.authentictionService.resetIdentity();
    this.authentictionService.logout();
  }
}
